/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, ElementRef, Input, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-tag-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatChipsModule, MatIconModule, MatFormFieldModule, MatInputModule],
  templateUrl: './tag-input.component.html',
  styleUrls: ['./tag-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TagInputComponent),
      multi: true
    },
  ]
})
export class TagInputComponent implements ControlValueAccessor {
  public tags: string[] = [];
  onChange: (tags: string[]) => void = () => {};
  onTouched: () => void = () => {};
  @Input() readonly = false;
  public tagInputControl = new FormControl('');

  @ViewChild('tagInput') tagInput!: ElementRef<HTMLInputElement>;

  writeValue(tags: string[]): void {
    this.tags = tags || [];
  }
  registerOnChange(fn: (tags: string[]) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.tagInputControl.disable();
    } else {
      this.tagInputControl.enable();
    }
  }
  public addTag(event: MatChipInputEvent): void {
    const value = (event.value || '').trim().toLowerCase();
    const alreadyExist = this.tags.indexOf(value) !== -1;
    if (value && !alreadyExist) {
      this.tags = [...this.tags, value];
      this.notifyForm();
    }

    event.chipInput!.clear();
    this.tagInputControl.setValue('');
  }

  public removeTag(tag: string): void {
    this.tags = this.tags.filter(t => t !== tag);
    this.notifyForm();
  }

  private notifyForm(): void {
    this.onChange(this.tags);
    this.onTouched();
  }
}
